import type { LinkToResourceSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-resource';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToResource: TemplateOnlyComponent<LinkToResourceSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToResource };
